import { Injectable } from '@angular/core';
import { Api } from './api.service';
import moment from 'moment';
import {
  RouteModel,
  CustomerModel,
} from '@app/shared/models/route-allocation.model';
import { Observable } from 'rxjs';

@Injectable()
export class DeliveryService {
  controllerName = 'api/deliveryschedule';

  constructor(protected api: Api) { }

  public getListByVehicles(startDate: moment.Moment, endDate: moment.Moment, vehicleIds: number[], routeIds: number[]): Observable<CustomerModel[]> {
    const params: any = {
      startDate: startDate.format('L'), // MM/dd/yyyy
      endDate: endDate.format('L'), // MM/dd/yyyy
      vehicleIds: vehicleIds,
      routeIds: routeIds
    };
    return this.api.get(`${this.controllerName}/by-vehicles`, params);
  }



  addDelivery(
    data: RouteModel,
    customer: CustomerModel,
    fromDateFilter: moment.Moment,
    toDateFilter: moment.Moment,
    selectedDate: moment.Moment,
  ) {
    return this.api.post(`${this.controllerName}`, {
      id: customer.deliveryId,
      routeId: data.routeId,
      customerId: customer.id,
      driverId: data.driverId,
      vehicleId: data.vehicleId,
      startDate: moment(customer.startDate).format('L'), // MM/dd/yyyy
      endDate: customer.endDate && moment(customer.endDate).format('L') || null, // MM/dd/yyyy
      type: data.deliveryType,
      recurringType: data.recurringType,
      weekOfMonth: data.weekOfMonth,
      selectedDate: selectedDate.format('L'),
      fromDateFilter: fromDateFilter.format('L'), // MM/dd/yyyy
      toDateFilter: toDateFilter ? toDateFilter.format('L') : null, // MM/dd/yyyy
      order: customer.order ? customer.order : data.deliveries.length,
    });
  }
  updateDelivery(
    data: RouteModel,
    customer: CustomerModel,
    fromDateFilter: moment.Moment,
    toDateFilter: moment.Moment,
    selectedDate: moment.Moment,
  ) {
    return this.api.put(`${this.controllerName}`, {
      deliveryId: customer.deliveryId,
      routeId: data.routeId,
      customerId: customer.id,
      driverId: data.driverId,
      vehicleId: data.vehicleId,
      startDate: moment(customer.startDate).format('L'), // MM/dd/yyyy
      endDate: customer.endDate && moment(customer.endDate).format('L') || null, // MM/dd/yyyy
      type: data.deliveryType,
      recurringType: data.recurringType,
      weekOfMonth: data.weekOfMonth,
      selectedDate: selectedDate.format('L'),
      fromDateFilter: fromDateFilter.format('L'), // MM/dd/yyyy
      toDateFilter: toDateFilter ? toDateFilter.format('L') : null, // MM/dd/yyyy
    });
  }
  getDropdown(name: string) {
    return this.api.get(`${this.controllerName}/dropdown/${name}`);
  }

  delete(id: number, selectedDate: moment.Moment) {
    const params: any = {
      selectedDate: moment(selectedDate).format('L'),
    };
    return this.api.delete(`${this.controllerName}/${id}`, params);
  }

  getRouteDetail(id: number, startDate: string, endDate: string) {
    const params: any = {
      routeId: id,
      startDate: moment(startDate).format('L'), // MM/dd/yyyy
      endDate: moment(endDate).format('L'), // MM/dd/yyyy
    };
    return this.api.get(`${this.controllerName}/get-by-route`, params);
  }

  updateRouteDetail(data: any) {
    return this.api.put(`${this.controllerName}/update-route-detail`, data);
  }

  updateDeliveryOrder(route: RouteModel, selectDate: moment.Moment) {
    const data = {
      id: route.routeId,
      deliveries: route.deliveries,
      selectedDate: moment(selectDate).format('L')
    };
    return this.api.put(`${this.controllerName}/update-delivery-order`, data);
  }

  getSchduleById(id: number) {
    return this.api.get(`${this.controllerName}/${id}`);
  }
}
